import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: none;
  background-color: #eaf0d5;
  @media screen and (max-width: 768px) {
    display: block;
  }
  button {
    border: none;
  }
  .active {
    background: #101355;
  }
  .none {
    display: none;
  }
  .display {
    display: block;
  }
`;
export const Container = styled.div`
  width: 100%;
  // padding: 16px 16px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 16px !important;
  }
`;
export const Hamburger = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff33;

  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Close = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff33;
  position: absolute;
  right: 16px;
  top: 17px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavUserContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
export const UserNotification = styled.div<{ bellColor?: string }>`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    button:hover {
      background-color: transparent !important;
    }
    .nv-bellIcon {
      color: ${({ bellColor }) => bellColor || 'var(--icons-color)'} !important;
      width: 100px !important;
      height: auto !important;
    }
  }
`;
export const NaviMoblie = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100vh;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: hidden;
  ::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  background: #EAF0D5;
`;
export const Content = styled.div`
  padding: 80px 24px 0 24px;
  width: 100%;
  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
    color: black;
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      background-color: #000;
      margin-top: 8px;
    }
  }
  p {
    color: black;
    font-weight: 400;
    margin-bottom: 16px;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      background-color: rgba(75, 151, 91, 0.1);
    }
    &.active {
      background-color: #4B975B;
      color: white;
    }
  }
`;
export const User = styled.div`
  position: absolute;
  bottom: 40px;
  left: 24px;
  p {
    color: black;
    font-weight: 400;
    margin-bottom: 16px;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      background-color: rgba(75, 151, 91, 0.1);
    }
  }
`;

export const PopUpContainer = styled.div`
  width: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  .popup-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    padding: 20px 40px;
    color: var(--primary-label-color);
  }
`;
